import * as React from "react";
import { styled } from "@mui/system";
import MUIInputAdornment from "@mui/material/InputAdornment";
import { InputAdornmentProps as InputAdornmentPropsMUI } from "@mui/material/InputAdornment";
export interface ExtendedInputAdornmentProps extends InputAdornmentPropsMUI {
  /**
   * Extended property, If want to change background in white colore for light theme and surface Default for dark theme.
   * @default false
   */
  adornmentBg?: boolean;
  /**
   * Extended property, for disabled style.
   * @default false
   */
  disabled?: boolean;
}

export const ExtendedInputAdornment: React.FC<ExtendedInputAdornmentProps> =
  styled(
    React.forwardRef<HTMLDivElement, ExtendedInputAdornmentProps>(
      (props, ref) => {
        const { adornmentBg = false, disabled = false, ...rest } = props;

        return <MUIInputAdornment ref={ref} {...rest} />;
      }
    ),
    {
      name: "InputAdornment",
      slot: "Root",
      overridesResolver: (props, styles) => []
    }
  )<ExtendedInputAdornmentProps>(
    ({ theme, position, adornmentBg, disabled }) =>
      adornmentBg && {
        background: theme.palette.primary.surfaceDefault,
        maxHeight: "40px",
        height: "40px",
        padding: "0px 10px",
        borderRight:
          position === "start" &&
          "1px solid " + theme.palette.primary.borderDefault,
        borderLeft:
          position === "end" &&
          "1px solid " + theme.palette.primary.borderDefault,

        "&.MuiInputAdornment-root .MuiTypography-root": {
          color: disabled
            ? theme.palette.primary.textDisabledColor
            : theme.palette.primary.textSubduedColor
        },
        "&.MuiInputAdornment-root": {
          marginLeft: 0,
          marginRight: 0
        }
      }
  );
